module.exports = __webpack_public_path__ + "static/media/github.69b7e397.png";